var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplayMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.66406H10C7.64298 1.66406 6.46447 1.66406 5.73223 2.45262C5 3.24118 5 4.51035 5 7.04868V7.94611C5 10.4845 5 11.7536 5.73223 12.5421C6.46447 13.3307 7.64298 13.3307 10 13.3307H13.3333C15.6903 13.3307 16.8688 13.3307 17.6011 12.5421C18.3333 11.7536 18.3333 10.4845 18.3333 7.94611V7.04868C18.3333 4.51035 18.3333 3.24118 17.6011 2.45262C16.8688 1.66406 15.6903 1.66406 13.3333 1.66406Z",
    fill: "currentColor",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 13.8376C14.9902 15.7921 14.9098 16.8506 14.2695 17.5411C13.5372 18.3307 12.3585 18.3307 10.0012 18.3307H6.66753C4.31026 18.3307 3.13162 18.3307 2.39931 17.5411C1.66699 16.7515 1.66699 15.4806 1.66699 12.9389V12.0403C1.66699 9.49856 1.66699 8.22771 2.39931 7.4381C2.93378 6.86181 3.70601 6.70612 5.00068 6.66406",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayMode);
export default __webpack_public_path__ + "static/media/display_mode.cdc3f2fc0c12bef1dc85da8c2842f124.svg";
export { ForwardRef as ReactComponent };